import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import DraggableContainer from './draggablecontainer';

const TestContent = styled.div`
  padding: 20px;
  width: 400px;
  background: white;
  border-radius: 8px;
  transform-origin: ${props => props.origin};
  animation: ${props => props.isClosing ? 'shrinkToButton' : 'growFromButton'} 0.3s ease-out forwards;

  @keyframes growFromButton {
    from {
      transform: scale(0.1) translate(${props => props.translateFrom});
      opacity: 0;
    }
    to {
      transform: scale(1) translate(0, 0);
      opacity: 1;
    }
  }

  @keyframes shrinkToButton {
    from {
      transform: scale(1) translate(0, 0);
      opacity: 1;
    }
    to {
      transform: scale(0.1) translate(${props => props.translateFrom});
      opacity: 0;
    }
  }
`;

const Field = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    font-weight: 500;
    margin-bottom: 8px;
    color: #333;
  }

  input, textarea {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #f8fafc;
    
    &:focus {
      outline: none;
      border-color: #00aef7;
      background: white;
    }
  }
`;

const TestProfile = ({ onClose, buttonRef }) => {
  const [isClosing, setIsClosing] = useState(false);
  const [animationOrigin, setAnimationOrigin] = useState('center');
  const [translateValues, setTranslateValues] = useState('0, 0');

  useEffect(() => {
    if (buttonRef?.current) {
      const button = buttonRef.current;
      const buttonRect = button.getBoundingClientRect();
      const x = buttonRect.left + (buttonRect.width / 2);
      const y = buttonRect.top + (buttonRect.height / 2);
      setAnimationOrigin(`${x}px ${y}px`);
      
      // Calculate translation values
      const translateX = (window.innerWidth / 2 - x) / 10;
      const translateY = (window.innerHeight / 2 - y) / 10;
      setTranslateValues(`${translateX}px, ${translateY}px`);
    }
  }, [buttonRef]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // Match animation duration
  };

  return (
    <DraggableContainer onClose={handleClose} title="Profile Editor Test">
      <TestContent 
        origin={animationOrigin}
        translateFrom={translateValues}
        isClosing={isClosing}
      >
        <Field>
          <label>Company Name</label>
          <input type="text" placeholder="Enter company name" />
        </Field>
        <Field>
          <label>About Us</label>
          <textarea rows={5} placeholder="Tell us about your company" />
        </Field>
        <Field>
          <label>Contact Information</label>
          <input type="tel" placeholder="Phone number" />
          <input type="email" placeholder="Email address" />
        </Field>
      </TestContent>
    </DraggableContainer>
  );
};

export default TestProfile;